<ng-container *ngIf="vm$ | async as vm">
  <div class="catalog-products__container flex--column">
    <agr-table-v2 [dataSource]="dataSource" [tableLayoutKey]="tableDisplayMode === 'list' ? null : tableDisplayMode">
      <ng-container *agrTableFiltersWrapper [formGroup]="search">
        <div class="flex flex--row flex--nowrap border-bottom--gray4">
          <agr-table-search formControlName="search" [label]="'search' | translate" class="catalog-products__search table-filter__item"> </agr-table-search>

          <app-table-display-mode
            *ngIf="isDesktopDisplay$ | async"
            [initialTableDisplayMode]="tableDisplayMode"
            (tableDisplayModeChanged)="setTableDisplayMode($event)"
            class="table-filter__item"
          ></app-table-display-mode>
          <app-table-sort-mode (sortModeChange)="onSortModeChange($event)" class="catalog-products__sort-dropdown table-filter__item"></app-table-sort-mode>
        </div>
      </ng-container>

      <agr-table-top-bar *agrTableTopBar class="catalog-products__top-bar">
        <div class="catalog-products__found-info" *ngIf="selectedCatalogCategory$ | async">
          <div class="catalog-products__found-info__text">{{ dataSource.total$ | async }} {{ 'app.catalog.table.found-products' | translate }}</div>
          <button
            #openProductSearchButton
            mat-button
            *ngIf="totalProductsFound || totalProductsFound === 0"
            class="catalog-products__found-info__text-more"
            (click)="openProductSearch()"
          >
            {{ totalProductsFound }}
            {{ (totalProductsFound === 1 ? 'app.catalog.table.more-found-product' : 'app.catalog.table.more-found-products') | translate }}
          </button>
        </div>
      </agr-table-top-bar>

      <ng-container matColumnDef="description">
        <td mat-cell *matCellDef="let row; let i = index">
          <app-catalog-product-description
            data-test="catalog-products-description"
            [catalogItem]="row"
            (click)="openWizardDialog(row, i)"
            [disabled]="!row.isUserAllowedToOrderItem"
          ></app-catalog-product-description>
        </td>
      </ng-container>

      <ng-container matColumnDef="quantity">
        <td mat-cell *matCellDef="let row; let i = index">
          <div class="catalog-products__quantity-column flex--row flex--align-end">
            <mat-form-field
              floatLabel="auto"
              subscriptSizing="dynamic"
              appearance="fill"
              (click)="$event.stopPropagation()"
              class="catalog-products__quantity-column__form-field"
            >
              <input
                matInput
                [step]="row.sku?.orderingInformation?.increaseOrderUnitQuantity ?? 1"
                [min]="row.sku?.orderingInformation?.minimumOrderUnitQuantity ?? 0"
                [max]="row.sku?.orderingInformation?.maximumOrderUnitQuantity"
                [formControl]="$any(vm.form.at(i).get('quantity'))"
                agrNumber
                [placeholder]="row.sku?.orderUnit"
                data-test="catalog-products-quantity"
              />
              <span
                *ngIf="row.sku?.orderingInformation?.orderUnit"
                matIconSuffix
                data-test="table-desktop__input-number-suffix"
                [attr.data-translate-key]="row.sku?.orderingInformation?.orderUnit"
              >
                {{ row.sku?.orderingInformation?.orderUnit }}
              </span>
            </mat-form-field>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="addToCart">
        <td mat-cell *matCellDef="let row; let i = index">
          <div class="catalog-products__button-column flex--row flex--align-end">
            <button
              mat-flat-button
              color="primary"
              class="text--small catalog-products__button"
              data-test="catalog-products-add-to-cart"
              (click)="addToCart(row, i)"
              [disabled]="!vm.form.at(i).get('quantity').valid || !row.isUserAllowedToOrderItem"
            >
              <mat-icon *ngIf="row.isUserAllowedToOrderItem" class="catalog__add-shopping-icon">add_shopping_cart</mat-icon>
              <span *ngIf="(isDesktopDisplay$ | async) && { value: hasAtLeastAdvisorRole$ | async } as hasAtLeastAdvisorRole">
                {{
                  row.sku
                    | formatAddProductToCartButtonText: { hasAtLeastAdvisorRole: hasAtLeastAdvisorRole.value, useDefaultText: env.ALLOWED_ORDER_ROLES_DISABLED }
                    | translate
                }}
              </span>
            </button>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="favoriteStar">
        <td mat-cell *matCellDef="let row; let i = index">
          <app-favorites-star class="favorite-star" *ngIf="this.isFavoritesEnabled" [skuId]="row.sku.skuId"></app-favorites-star>
        </td>
      </ng-container>

      <ng-container matColumnDef="singleMobileColumn">
        <td mat-cell *matCellDef="let row; let i = index">
          <app-catalog-product-description
            class="catalog-products__description-column"
            [catalogItem]="row"
            (click)="openWizardDialog(row, i)"
            [disabled]="!row.isUserAllowedToOrderItem"
          ></app-catalog-product-description>

          <app-favorites-star class="flex--align-start" class="favorite-star" [skuId]="row.sku.skuId"></app-favorites-star>

          <div class="flex--row flex--align-end">
            <button
              mat-flat-button
              color="primary"
              class="text--small catalog-products__button catalog-products__button--mobile"
              data-test="catalog-products-add-to-cart"
              (click)="addToCart(row, i)"
              [disabled]="!row.isUserAllowedToOrderItem"
            >
              <mat-icon class="catalog-products__button--mobile-icon">add_shopping_cart</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-row *matRowDef="let _; columns: columnsToDisplay"></tr>

      <div *matNoDataRow>
        <agr-notification-empty data-test="products-emtpy" [isEmpty]="isEmpty$ | async" [emptyTitle]="isEmptyText"></agr-notification-empty>
      </div>

      <app-catalog-product-grid
        gridTableLayout
        [data]="dataSource.data$"
        (addToCartClicked)="addToCart($event)"
        (descriptionClicked)="openWizardDialog($event)"
      ></app-catalog-product-grid>
    </agr-table-v2>
  </div>
</ng-container>
